import React, { forwardRef, useId } from 'react';
import maritimeSprite from '../../assets/icons/cruisingos-maritime-sprite-v2.png';

import { maritimeIconBounds, maritimeIconViewBox, maritimeSpriteSize } from './maritimeIconData';
export { maritimeIconBounds } from './maritimeIconData';

/** PNG artwork masked with currentColor, with the same SVG surface as Tabler. */
export const MaritimeIcon = forwardRef(function MaritimeIcon({
  variant = 'ship only', size = 18, color = 'currentColor', title, children,
  stroke, // The stroke weight belongs to the supplied artwork.
  ...props
}, ref) {
  const maskId = `maritime-${useId().replace(/:/g, '')}`;
  const viewBox = maritimeIconViewBox(variant);
  const accessible = Boolean(title || props['aria-label'] || props['aria-labelledby']);

  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size}
      viewBox={viewBox} color={color} fill="currentColor"
      role={accessible ? 'img' : undefined} aria-hidden={accessible ? undefined : true}
      focusable="false" {...props} data-maritime-icon={variant}>
      {title && <title>{title}</title>}
      {children}
      <defs>
        <mask id={maskId} x="0" y="0" width={maritimeSpriteSize.width} height={maritimeSpriteSize.height}
          maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
          <image href={maritimeSprite} width={maritimeSpriteSize.width} height={maritimeSpriteSize.height} />
        </mask>
      </defs>
      <rect width={maritimeSpriteSize.width} height={maritimeSpriteSize.height} mask={`url(#${maskId})`} />
    </svg>
  );
});

export const maritimeIcons = Object.fromEntries(Object.keys(maritimeIconBounds).map((variant) => {
  const Icon = forwardRef((props, ref) => <MaritimeIcon {...props} ref={ref} variant={variant} />);
  Icon.displayName = `MaritimeIcon(${variant})`;
  return [variant, Icon];
}));
